import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[chipItem]',
})
export class ChipItemDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}
